import { eventHasRun } from '../../utils/eventTracker';
import { getHexBackgroundColor } from '../../utils/getBackgroundColor';
import { getCtaIndex } from '../../utils/getCtaIndex';
import widgetIsPresent from '../../utils/widgetIsPresent';
import getLinkText from '../../utils/getLinkText';
import findVehicleByProperty from '../../utils/findVehicleByProperty';

export const DDC_LINK_GENERIC = 'ddc.link.generic';

function clicked(win, { currentTarget: element, timeStamp, originalEvent }) {
	const {
		DDC: {
			dataLayer: {
				page: {
					pageInfo: { isVlp, pageWidgets }
				},
				vehicles
			}
		}
	} = win;
	let eventObject;
	if (
		!eventHasRun(DDC_LINK_GENERIC, {
			timeStamp
		}) &&
		element instanceof Element &&
		element?.getAttribute?.('ui-tabs-initial-load') !== 'true' &&
		// US784493 - Next line added so we do not track internal event viewer
		!originalEvent?.path?.some?.((el) =>
			el?.classList?.contains?.('hide-from-ws-tracking')
		) &&
		[undefined, null].includes(
			originalEvent?.target?.closest?.('.hide-from-ws-tracking')
		)
	) {
		if (
			element?.classList?.contains?.('dialog') &&
			!$(element).parents('.ui-dialog').length
		) {
			localStorage?.setItem(
				'ddc_data_layer-initiatingClickText',
				$(element).text().trim()
			);
		}

		let department;
		let departmentId;
		let containsImage = false;

		if (element.href?.startsWith('tel:')) {
			const dataClickToCall = element?.closest('[data-click-to-call]')
				?.dataset?.clickToCall;
			const dataClickToCallId = element?.closest(
				'[data-click-to-call-id]'
			)?.dataset?.clickToCallId;
			const dataTrackingDept = element?.closest(
				'[data-ws-tracking-department]'
			)?.dataset?.wsTrackingDepartment;
			const dataPhoneRef =
				element?.closest('[data-phone-ref]')?.dataset?.phoneRef;
			department =
				dataClickToCall ||
				dataClickToCallId ||
				dataTrackingDept ||
				(dataPhoneRef !== 'null' && dataPhoneRef);
			departmentId = dataClickToCallId || null;
		}

		if (element.querySelector('img')) {
			containsImage = true;
		}

		const oemId = element?.closest('[data-oem-id]')?.dataset?.oemId;

		const eventData = {
			text: getLinkText(element, win),
			url: element?.getAttribute?.('href') || '',
			pageName: win.DDC.dataLayer.page.pageInfo.pageName,
			element,
			containsImage,
			backgroundColor: getHexBackgroundColor(element),
			ctaIndex: getCtaIndex(element),
			isSRP: widgetIsPresent(/ws-inv-listing/, pageWidgets),
			isIncentivePanel:
				($(element).closest('.multi-incentive-modal').length > 0 ||
					$(element).closest('.single-incentive-modal').length > 0) &&
				$(element).closest('.panel-title').length > 0,
			...(department && { department, departmentId }),
			...(oemId && { oemId })
		};

		if ($(element).closest('.ddc-footer').length > 0) {
			eventData.location = 'footer';
		} else if (
			$(element).closest('.navbar-nav').length > 0 ||
			$(element).closest('.navbar-default').length > 0 ||
			$(element).closest('.ddc-mobile-fragment-nav').length > 0
		) {
			eventData.location = 'mainNav';
		} else if ($(element).closest('.page-header').length > 0) {
			eventData.location = 'header';
		} else {
			eventData.location = 'content';
		}
		if ($(element).closest('.vehicle-ctas').length && isVlp) {
			eventData.isSrpVehicleCta = true;
		}
		if (eventData.isSRP) {
			const uuid =
				$(element).closest('[data-uuid]').attr('data-uuid') || '';
			const vehicle = uuid
				? findVehicleByProperty('uuid', uuid, vehicles)
				: {};
			eventData.vehicle = vehicle;
		} else if (win.DDC.dataLayer.page.pageInfo.isVdp) {
			[eventData.vehicle] = vehicles;
		}

		if (eventData.isIncentivePanel) {
			eventData.dataIncentiveId = $(element)
				.closest('.panel')
				.find('[data-incentive-id]')
				.attr('data-incentive-id');
			eventData.dataIncentiveName = $(element)
				.closest('.panel')
				.find('[data-incentive-id]')
				.attr('data-incentive-name');
		}
		eventObject = {
			eventType: DDC_LINK_GENERIC,
			eventData
		};
	}

	if (element instanceof Element) {
		element?.setAttribute?.('ui-tabs-initial-load', false);

		if (
			element.querySelector('i') !== null &&
			element.querySelector('i').className.includes('menu')
		) {
			eventObject.eventData.isHamburgerMenu = true;
		}
	}

	return eventObject;
}

export default clicked;
